import { render, staticRenderFns } from "./AppWorkspaceMenuItem.vue?vue&type=template&id=295b80b3&scoped=true"
import script from "./AppWorkspaceMenuItem.vue?vue&type=script&lang=js"
export * from "./AppWorkspaceMenuItem.vue?vue&type=script&lang=js"
import style0 from "./AppWorkspaceMenuItem.vue?vue&type=style&index=0&id=295b80b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b80b3",
  null
  
)

export default component.exports